import React from 'react'
import { useMutation, useQuery } from '@tanstack/react-query'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { SvgLazy } from '@mobi/component-library/Common/Svg/SvgLazy'
import { TabButton, Tabs } from '@mobi/component-library/Navigation/Tabs'
import { MainContainer } from '@core/Components/Containers'
import { queryClient } from '@core/Data/ReactQuery'
import { postCreateBetLoopProfile } from '@core/Areas/BetLoop/helpers/api'
import { betLoopPrincipleProfileQuery } from '@core/Areas/BetLoop/helpers/queries'
import { SkeletonLoader } from '@core/Areas/BetLoop/Components/Common/SkeletonLoader'
import { SortButtonBar } from '@core/Areas/BetLoop/Components/Common/SortFeed/Components/SortButtonBar'
import { BetLoopTAndCsModal } from './Components/BetLoopTAndCsModal'
import { ProfileCreationDisplayTray } from './Components/ProfileCreationDisplayTray'
import { FeedContainerStyled } from '../Common/BetLoop.styles'

export const OnboardingManager: React.FC<{ onCompleteOnboarding(): void }> = ({
  onCompleteOnboarding,
}) => {
  const [isTCsModalOpen, setIsTCsModalOpen] = React.useState(true)
  const { data } = useQuery(betLoopPrincipleProfileQuery)

  const { mutate: createProfile, isPending: isCreatingProfile } = useMutation({
    mutationFn: postCreateBetLoopProfile,
    onSuccess() {
      queryClient.invalidateQueries(betLoopPrincipleProfileQuery)
    },
    onSettled() {
      setIsTCsModalOpen(false)
    },
  })

  const onAcceptAndContinueClick = () => {
    createProfile()
  }

  return (
    <MainContainer background='surface300'>
      <PageHeader title={<SvgLazy name='BetLoopHeaderLogo' height='4rem' color='white' />} />

      <Tabs>
        <TabButton content='Explore' isSelected onClick={() => null} />
        <TabButton content='Following' isSelected={false} onClick={() => null} />
      </Tabs>

      <SortButtonBar label='Next to Jump' onClick={() => null} />

      <FeedContainerStyled>
        <SkeletonLoader />
      </FeedContainerStyled>

      <BetLoopTAndCsModal
        isOpen={isTCsModalOpen}
        onAccept={onAcceptAndContinueClick}
        isCreatingProfile={isCreatingProfile}
      />

      <ProfileCreationDisplayTray profileData={data} onCompleteOnboarding={onCompleteOnboarding} />
    </MainContainer>
  )
}
